exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section-header[data-v-626dde76] {\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(24, 28, 33, 0.06);\n    margin-bottom: 20px;\n    margin-top: 80px;\n}\n.section-header-muted[data-v-626dde76] {\n    font-weight: normal;\n    color: #a3a4a6 !important;\n}\n.break-protect[data-v-626dde76] {\n    page-break-inside: avoid;\n}\n.body[data-v-626dde76] {\n    margin: 25mm;\n}\n@page {\n    margin-top: 1in;\n    margin-bottom: 1in;\n}\n", ""]);

// exports
